import config from '../config/app';
import * as Cognito from 'amazon-cognito-identity-js';
import AWS from 'aws-sdk';

export const getUserPool = () => {
    const poolData = {
        UserPoolId: config.aws.cognito.UserPoolId,
        ClientId: config.aws.cognito.ClientId,
        Storage: sessionStorage // セッションストレージを指定することでセッション情報はブラウザを閉じた時に自動で削除される
    };

    return new Cognito.CognitoUserPool(poolData);
};

export const refresh = () => {
    const user = JSON.parse(sessionStorage.getItem('user'));

    return new Promise((resolve, reject) => {
        if (!user) {
            reject()
        }
        const userPool = getUserPool();
        const cognitoUser = new Cognito.CognitoUser({
            Username: user.username,
            Pool: userPool,
            Storage: sessionStorage // セッションストレージを指定することでセッション情報はブラウザを閉じた時に自動で削除される
        });

        const tokens = JSON.parse(sessionStorage.getItem("tokens"));
        const refreshToken = new Cognito.CognitoRefreshToken({
            RefreshToken: tokens.refreshToken.token
        });

        cognitoUser.refreshSession(refreshToken, (err, result) => {
            if (err) {
                reject(err);
            } else {
                sessionStorage.setItem("tokens", JSON.stringify(result));
                resolve(result);
            }
        });
    });
};

export const login = params => {
    const authenticationData = {
        Username: params.username,
        Password: params.password,
    };

    const authenticationDetails = new Cognito.AuthenticationDetails(authenticationData);

    const userPool = getUserPool();
    const cognitoUser = new Cognito.CognitoUser({
        Username: params.username,
        Pool: userPool,
        Storage: sessionStorage // セッションストレージを指定することでセッション情報はブラウザを閉じた時に自動で削除される
    });

    return new Promise((resolve, reject) => {
        const authConfig = {
            onSuccess(result) {
                const user = userPool.getCurrentUser();
                cognitoUser.getUserAttributes((err, attributes) => {
                    const attr = {};
                    attributes.map(attribute => {
                        attr[attribute.Name] = attribute.Value;
                    });
                    sessionStorage.setItem("attributes", JSON.stringify(attr));
                    sessionStorage.setItem('user', JSON.stringify(user));
                    sessionStorage.setItem('tokens', JSON.stringify(result));

                    resolve(user);
                });
            },
            onFailure(err) {
                console.log(err);
                reject(err);
            },
            newPasswordRequired(userAttributes, requiredAttributes) {
                console.log("newPasswordRequired()");
                console.log(userAttributes, requiredAttributes);
                cognitoUser.completeNewPasswordChallenge(params.password, {}, authConfig);
            },
            mfaRequired(challengeName, challengeParameters) {
                console.log("mfaRequired()");
                console.log(challengeName, challengeParameters);
            },
            customChallenge(challengeParameters) {
                console.log("customChallenge()");
                console.log(challengeParameters);
            }
        };

        cognitoUser.authenticateUser(authenticationDetails, authConfig);
    });
};

export const logout = () => {
    const userPool = getUserPool();
    const cognitoUser = userPool.getCurrentUser();

    return new Promise((resolve, reject) => {
        if (cognitoUser) cognitoUser.signOut();
        resolve();
    });
};

export const getCredentials = () => {
    const userPool = getUserPool();
    const cognitoUser = userPool.getCurrentUser();

    return new Promise((resolve, reject) => {
        if (cognitoUser === null) {
            reject("User not found.")
        } else {
            cognitoUser.getSession((err, session) => {
                if (err) {
                    reject(err);
                } else {
                    const Logins = {};
                    Logins[`cognito-idp.${config.aws.region}.amazonaws.com/${config.aws.cognito.UserPoolId}`] = session.getIdToken().getJwtToken();

                    resolve(
                        new AWS.CognitoIdentityCredentials({
                            Logins,
                            IdentityPoolId: config.aws.cognito.IdentityPoolId,
                        }, {
                            region: config.aws.region
                        })
                    );
                }
            });
        }
    });
};


// WEBPACK FOOTER //
// ./src/api/session.js